"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.take = void 0;
var safe_slice_1 = require("./safe-slice");
/** @internal */
var take = function (array, num) {
    return (0, safe_slice_1.safeSlice)(array, 0, num);
};
exports.take = take;
